import React from "react";
const AuthCardLeft = props => {
  return (
    <div className={props.className}> 
      {props.children}
    </div>
  );
};

export default AuthCardLeft;